import axios from "axios";
import {URLAPI} from "../Constantes";

export const obtenerDatosTransaccion = async (idTransaccion) => {


     return axios.get(URLAPI + '/' + idTransaccion)
        .then(function (response) {
            //console.log(response);
            // handle success
          //  console.log(response.data); // The fetched data is typically in response.data
            return response.data.data
        })
        .catch(function (error) {
            // handle error
          //  console.log(error);

            return false

        });


}